import Cookies from 'js-cookie';
import { types } from './actions';
import { types as loginActionTypes } from '../LoginView/actions';

import initialState from '../../stores/initialState';

function retriveRedirectionUrl(currentUserprivileges) {
  const noPrivRedirection = '/shell/solumina?autoOpenMenu=true';

  // The ORDER OF PRIVILEGES IS IMPORTANT, DO NOT CHANGE THE ORDER
  const privToHomePageMap = new Map([
    ['PLANNER_HOMEPAGE', '/shell/solumina/dispatch/Planner%20Home%20Page'],
    ['PLANNER_SUPERVISOR', '/shell/solumina/dispatch/Planner%20Supervisor%20Home%20Page'],
    ['SHOPFLOOR_SUPERVISOR_HOMEPAGE', '/shell/solumina/dispatch/Shop%20Floor%20Supervisor%20Home%20Page'],
    ['SHOPFLOOR_USER_HOMEPAGE', '/shell/solumina/dispatch/Shop%20Floor%20Technician%20Home%20Page'],
    ['DISPATCH_TOOL', '/shell/solumina/dispatch/Tools%20and%20Machines%20Calibration%20Status'],
    ['PROD_EXPEDITER', '/production-controller'],
    ['ORDER_CREATE', '/shell/solumina/dispatch/Production%20Release%20Control'],
    ['QUALITY_HOMEPAGE', '/shell/solumina/dispatch/SF%20Quality%20Home%20page'],
    ['DISPATCH_CUST', '/shell/solumina/dispatch/SF%20Quality%20Home%20page'],
    ['SUPPLIER_PORTAL', '/sqa-inspector'],
    ['USER_VIEW', '/shell/solumina/dispatch/users'],
    ['UI_CONFIGURATION', '/webui-configurator-tool'],
  ]);

  const matchedPrivilege = Array.from(privToHomePageMap.keys()).find(priv => currentUserprivileges.includes(priv));
  if (matchedPrivilege) {
    return privToHomePageMap.get(matchedPrivilege);
  }
  return noPrivRedirection;
}

function getRedirectPath({ currentRedirectTo = '/', currentUserprivileges = [] }) {
  let nextRedirectTo = currentRedirectTo;
  if (['/', '/login'].indexOf(nextRedirectTo) !== -1 || !nextRedirectTo) {
    nextRedirectTo = retriveRedirectionUrl(currentUserprivileges);
  }
  return nextRedirectTo;
}

// eslint-disable-next-line default-param-last
function authReducer(state = initialState.auth, action) {
  switch (action.type) {
    case types.VALIDATE_TOKEN_FULFILLED:
      return { ...state,
        validToken: action.result.valid,
        isExternalUser: action.result.isExternalUser === 'Y',
        redirectTo: action.payload.url,
        requestProcessed: !state.requestProcessed };
    case types.VALIDATE_TOKEN_REJECTED:
      return { ...state,
        validToken: false,
        isExternalUser: false,
        redirectTo: '/',
        requestProcessed: !state.requestProcessed };
    case loginActionTypes.LOGIN_FULFILLED:
      {
        const redirectTo = getRedirectPath({
          currentRedirectTo: action.data?.redirect || state.redirectTo || Cookies.get('redierctURL'),
          currentUserprivileges: action.result.privileges
        });
        Cookies.remove('redierctURL');
        return { ...state, redirectTo };
      }
    case loginActionTypes.USER_PRIVILEGES_FULFILLED:
      {
        const redirectTo = getRedirectPath({
          currentRedirectTo: state.redirectTo,
          currentUserprivileges: action.result
        });
        return { ...state, redirectTo };
      }
    case loginActionTypes.USER_PRIVILEGES_REJECTED:
      {
        return { ...state, validToken: false, requestProcessed: true };
      }
    default:
      return state;
  }
}

export default authReducer;